import { Injectable } from '@angular/core';
import { Constant } from '../constant/constant';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CountryLocationService {

  private url = 'https://ipapi.co//json/';

  constructor(private http: HttpClient) { }

  getCountryCode(){
    return  getConfig() ;
  }
}


function getConfig() {
  let config;

  function tryRequest(url: string): any | null {
    let req = new XMLHttpRequest();
    try {
      req.open('GET', url, false);
      req.send(null);
      if (req.status === 200) {
        return JSON.parse(req.responseText);
      }
    } catch (e) {
      console.error('getConfig: request failed for', url, e);
    }
    return null;
  }

  try {
    let obj = tryRequest('https://ipinfo.io/json');

    if (!obj) {
      // Fallback to ipapi.co if ipinfo.io fails
      const fallback = tryRequest('https://ipapi.co/json/');
      if (fallback) {
        obj = {
          ip: fallback.ip,
          city: fallback.city,
          region: fallback.region,
          country: fallback.country_name,
          country_code: fallback.country,
          postal: fallback.postal,
          timezone: fallback.timezone,
          org: fallback.org
        };
      }
    } else {
        // Normalize fields from ipinfo.io
        obj = {
          ip: obj.ip,
          city: obj.city,
          region: obj.region,
          country: obj.country,
          country_code: obj.country,
          postal: obj.postal,
          timezone: obj.timezone,
          org: obj.org
        };
    }

    if (obj) {
      config = JSON.stringify(obj);
      localStorage.setItem(Constant.COUNTRY_LOCATION, JSON.stringify(obj));
    }
  } catch (e) {
    console.error('environment:getConfig: unable to get location: ', e);
  }

  return config;
}
